
import { useEffect,useState,useContext } from "react";
import "./Dashboard.css"
import { axiosPrivate } from "../../api/axios";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import AuthContext from "../../Context/AuthProvider";
// import { countDocuments } from "../../../../../nerdayB/NerdayB/Models/UserModel";



function Compensation(){  

    const[tData, setTData] = useState([]);
    const [searchData, setSearchData] = useState(""); 
    const { setAuth,auth } = useContext(AuthContext);

  const [users, setUsers] = useState();
  const [modeZ, setMode] = useState();
  const axiosPrivate = useAxiosPrivate();


      async function populateData(){  

            // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
            const response = await fetch("http://localhost:2001/api/Alltransactions",{
            // const response = await fetch("https://nerdayb.onrender.com/api/Alltransactions",{
                headers : { 
                //   'x-access-token' : auth.user,
                }
            // body: JSON.stringify({
            //     quote,
                
            // })
            })
            
            const data = await response.json();
            console.log("All Data here",data.propdata)
            if(data){

        if(data.status == "ok") {
            setTData(data.propdata)
            setSearchData(data.propdata)
            }else{
            //    alert(data.error,"Here!")
            console.log("testign first")
            } 

        }
        
      //   console.log(data,"aync test");
        
        return data;
        
  } 


  const dataMode = (data) => {

            var count = 0;
            var PaySum = 0;
            var avg = 0;
            var Active = 0;
            var InAactive = 0;
            var Male = 0; 
            var Female = 0; 

            console.log("In function")


            for (var i=0; i<data.length; i++){
                console.log("Gender",data[i].Gender)
                count = i;
                PaySum = data[i].Base_Pay+PaySum;
                avg = PaySum/count;

                if (data[i].Gender=="FEMALE"){
                  
                    Female++;
                }
                if (data[i].Gender=="MALE"){
                 
                    Male++;
                }
                if (data[i].status == "Active"){
                   
                    Active++;
                }
                
            }

             setMode( {
                count,
                PaySum,
                avg,
                Active,
                Male,
                Female
            
            })

            return  count;

  }



//   const navigate = useNavigate();
//   const location = useLocation();

  useEffect(() => {
      let isMounted = true;
      const controller = new AbortController();

      const getUsers = async () => {
          try {
              const response = await axiosPrivate.get('/users', {
                  signal: controller.signal,
                  params: {
                
                    Org: auth.foundUser.Org,
                    // Org: auth.auth.foundUser.Org,
                    // org: 'value2',
                    // mgtLvl: 'value2',
                 
                  }

              });
              console.log(response.data);
              console.log("Here");
              isMounted && setUsers(response.data);
              setTData(response?.data)
              dataMode(response?.data)

              
          } catch (err) {
              console.error(err);
            //   navigate('/login', { state: { from: location }, replace: true });
          }
      }
      console.log("contect",auth)
      getUsers();

      return () => {
          isMounted = false;
          controller.abort();
      }
  }, [])

  ///

    return <>

        <div className="CompensationCard">

        {/* <div className="cardHeading">
            <h2>TEAM</h2>
            </div> */}
                  <div className="statCover">
                           <div className="statCard">
                            
                                <div className="Label">
                                   <b><p>Total</p></b>  
                                </div>
                                <div className="Value">
                                <p>{modeZ?.count}</p>
                                </div>

                           </div>
                           <div className="statCard">
                            
                                <div className="Label">
                                   <b><p>Active</p></b>  
                                </div>
                                <div className="Value">
                                <p>{modeZ?.Active}</p>
                                </div>

                           </div>
                           <div className="statCard">
                            
                                <div className="Label">
                                   <b><p>Male</p></b>  
                                </div>
                                <div className="Value">
                                <p>{modeZ?.Male}</p>
                                </div>

                           </div>
                           <div className="statCard">
                            
                                <div className="Label">
                                   <b><p>Female</p></b>  
                                </div>
                                <div className="Value">
                                <p>{modeZ?.Female}</p>
                                </div>

                           </div>
                           <div className="statCard">
                            
                                <div className="Label">
                                   <b><p>Positions</p></b>  
                                </div>
                                <div className="Value">
                                <p>30</p>
                                </div>

                           </div>
                           <div className="statCard">
                            
                                <div className="Label">
                                   <b><p>Avg. Salary(zmk)</p></b>  
                                </div>
                                <div className="Value">
                                <p>{parseFloat(modeZ?.avg).toFixed(2)}</p>
                                </div>

                           </div>
                           

                  </div>

               
                <div className="compensationCard">
                    {/* <div className="InpuTsubject"><p><b>Gender</b></p></div>
                    <div className="InpuTvalue">Male</div> */}
                    <table className="contentTable"> 
                        <thead>
                            <tr>
                                <th></th>
                                <th>NAME</th>
                                <th>TITLE</th>
                                <th>ACCOUNT #</th>
                                <th>ACCOUNT</th>
                                <th>BRANCH</th>
                                <th>BASE PAY</th>
                                <th>FINANCIAL INSTITUTION</th>
                            </tr>
                        </thead>
                        {tData && tData

                        .filter((row,index)=>{



                            const date = new Date(row.TDate);
                            // Checks if the data is within the filter range
                            if ((row?.status == "Active")) {
                            //&&(row.TAccount == userData.AccountNo) && (row.transactionType == "Deduction")) {
                            
                                // "Advance Request","Advance Repayment"
                            //  console.log("status",row.status)
                                return row;
                            }
                            
                        })
                         
                        .map((Item,key)=>{
                            return(
                                <>
                                     <tbody>
                                            <tr>
                                                <td>{key+1}.</td>
                                                <td>{Item?.name}</td>
                                                <td>{Item?.Position}</td>
                                                <td>{Item?.AccountNo}</td>
                                                <td>{Item?.AccountType}</td>
                                                <td>{Item?.FInstitutionBranch}</td>
                                                <td>{`ZMK ${Item?.Base_Pay}`}</td>
                                                <td>{Item?.FInstitution}</td>
                                                {/* <td>adaga</td> */}
                                            </tr>
                                            {/* <tr>
                                                <td>boy</td>
                                                <td>giel</td>
                                                <td>adaga</td>
                                            </tr>
                                            <tr>
                                                <td>boy</td>
                                                <td>giel</td>
                                                <td>adaga</td>
                                            </tr> */}
                                        </tbody>
                                                
                                </>
                            )
                        })}
                       
                    </table>

                </div>
         
           
        </div>
        
    
    </>

}

export default Compensation;